import type React from 'react'

import styles from './view.module.css'

export function PostLayout({ children }: React.PropsWithChildren) {
    return <article className={styles.postArticle}>{children}</article>
}

function PostHeader({ children }: React.PropsWithChildren) {
    return <header className={styles.postFullHeader}>{children}</header>
}

function PostContent({ children }: React.PropsWithChildren) {
    return <section className={styles.postContent}>{children}</section>
}

function PostFooter({ children }: React.PropsWithChildren) {
    return <footer className={styles.postFooter}>{children}</footer>
}

PostLayout.Header = PostHeader
PostLayout.Content = PostContent
PostLayout.Footer = PostFooter
